export const SHIFT_ALLOCATION_MULTI_COMPANY = 'SHIFT_ALLOCATION_MULTI_COMPANY';

export type AllocationMultiCompanyAction = 'create' | 'close' | 'update' | 'remove-person' | 'delete';

export interface AllocationMultiCompanyOption {
    company_id: number;
    name: string;
    selected: boolean;
    locked: boolean;
}

export interface AllocationMultiCompanyDialogData {
    action: AllocationMultiCompanyAction;
    /** Empresa travada (sempre marcada) — null quando não há uma empresa de partida (ex.: criar do zero cross-company). */
    currentCompanyId: number | null;
    currentCompanyName: string;
    companies: { company_id: number; name: string }[];
}

export type AllocationMultiCompanyDialogResult =
    | { mode: 'cancel' }
    | { mode: 'confirm'; companyIds: number[] };

export const ALLOCATION_MULTI_COMPANY_ACTION_LABELS: Record<AllocationMultiCompanyAction, string> = {
    create: 'criar este turno',
    close: 'fechar este turno',
    update: 'salvar alterações deste turno',
    'remove-person': 'remover este profissional do turno',
    delete: 'remover este turno',
};
